// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import DashboardOutlined from '/app/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
import FormOutlined from '/app/node_modules/@ant-design/icons/es/icons/FormOutlined';
import SmileOutlined from '/app/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import TableOutlined from '/app/node_modules/@ant-design/icons/es/icons/TableOutlined';
import MessageOutlined from '/app/node_modules/@ant-design/icons/es/icons/MessageOutlined';
import CompassOutlined from '/app/node_modules/@ant-design/icons/es/icons/CompassOutlined';
export default { DashboardOutlined, FormOutlined, SmileOutlined, TableOutlined, MessageOutlined, CompassOutlined };
